import { Text } from "../Text";
import styled from "../../styled";
import { getPaletteText } from "../../utils/paletteConversions";
var palette = function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? 'secondary' : _b, _c = _a.isFocused, isFocused = _c === void 0 ? false : _c, _d = _a.isSelected, isSelected = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, theme = _a.theme;
    var text = theme.colors[getPaletteText(palette)];
    var main = theme.colors[palette];
    if (isSelected) {
        return "\n      color: " + text + ";\n      background: " + main + ";\n    ";
    }
    if (isFocused && !disabled) {
        return "\n      color: " + main + ";\n    ";
    }
    if (disabled) {
        return "\n      color: " + theme.colors.gray600 + ";\n    ";
    }
    return null;
};
export var OptionContainer = styled(Text)(palette, function (_a) {
    var theme = _a.theme, disabled = _a.disabled;
    return "\n  font-size: " + theme.typography.control.fontSize + ";\n  position: relative;\n  cursor: " + (disabled ? 'not-allowed' : 'pointer') + ";\n  display: block;\n  border: none;\n  height: auto;\n  text-align: left;\n  border-top: none;\n  text-transform: none;\n  box-shadow: none;\n  margin: 0;\n  padding: " + theme.space.sm + " " + theme.space.md + ";\n  white-space: normal;\n  word-wrap: normal;\n";
});
//# sourceMappingURL=OptionContainer.js.map